import { useQuery } from '@tanstack/react-query';

import {
  deductionRequestService,
  FetchDeductionRequestRequest,
  FetchDeductionRequestResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchDeductionRequests = (
  { individualIds, status, type, page, size, sortBy, sort }: FetchDeductionRequestRequest,
  enabled = true
) => {
  const toast = useToast();

  return useQuery<FetchDeductionRequestResponse, Error>(
    ['fetchDeductionRequests', individualIds, status, type, page, size, sortBy, sort],
    () =>
      deductionRequestService.fetchDeductionRequests({
        individualIds,
        status,
        type,
        page,
        size,
        sortBy,
        sort,
      }),
    {
      enabled,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: `Sorry, we failed to fetch the deduction requests. Please try again.`,
        });
      },
    }
  );
};

export default useFetchDeductionRequests;
